<template>
  <div class="header">
    <div class="rowFluid custemHead">
      <div class="span2 col-md-12">
        <div class="logo" style="padding-top: 10px">
          <a href="/">
            <img :src="logoPic" style="max-height: 30px">
          </a>
        </div>
      </div>
      <div class="span8">
        <div class="mobileMenuBtn">
          <span class="span1" style="background-color: #0F0F64"></span>
          <span class="span2"  style="background-color: #0F0F64"></span>
          <span class="span3"  style="background-color: #0F0F64"></span>
        </div>
        <div class="mobileMenuBtn_shad"></div>
        <div class="header_menu">
          <ul id="menu">

            <li v-for="(items,index) in bannerList" :key="index">
              <a style="cursor:pointer" :class="{active : type == items.bannerUrl}"  @click="goHere(items.bannerUrl)" :title='items.bannerName'>
                <span style="display: block;height: 16px;letter-spacing: 3px;padding-bottom:5px">{{items.subBannerName}}</span>
                <span style="font-size: 10px;">{{ items.bannerName }}</span>
              </a>

            </li>

          </ul>
        </div>
      </div>
      <div class="span2"></div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      logoPic: require('../../assets/images/logo_new6.png'),
      type: '/',
      bannerList: [
        {'bannerName': 'ホーム', 'subBannerName': 'HOME', 'bannerUrl': '/'},
        {'bannerName': 'サービス概要', 'subBannerName': 'SERVICE', 'bannerUrl': '/service'},
        {'bannerName': '情報セキュリティ', 'subBannerName': 'SECURITY', 'bannerUrl': '/security'},
        /*        {'bannerName': '会社情報2', 'subBannerName': 'Company2', 'bannerUrl': '/buildPlan'}, */
        {'bannerName': '会社情報', 'subBannerName': 'COMPANY', 'bannerUrl': '/company'},
        {'bannerName': '採用情報', 'subBannerName': 'RECRUIT', 'bannerUrl': '/recruit'},
        {'bannerName': 'お問い合わせ', 'subBannerName': 'CONTACTS', 'bannerUrl': '/contact'}

      ]
    }
  },
  watch: {
    '$route': function (to, from) {
      this.type = to.path
    }
  },
  methods: {
    goHere (item) {
    //  console.log(this.$route.params.type)
      this.type = item
      switch (item) {
        case '/':
          this.$router.push({ path: '/' })
          break

        case '/service':
          this.$router.push({ path: '/service' })
          break

        case '/aboutus':
          this.$router.push({ path: '/aboutus' })
          break

        case '/company':
          this.$router.push({ path: '/company' })
          break

        case '/buildPlan':
          this.$router.push({ path: '/buildPlan' })
          break

        case '/security':
          this.$router.push({ path: '/security' })
          break

        case '/recruit':
          this.$router.push({ path: '/recruit' })
          break

        case '/contact':
          this.$router.push({ path: '/contact' })
          break
      }
    }
  }
}
</script>
<style lang="less" rel="stylesheet/less" scoped>
@import "../../assets/css/mixin.less";
</style>



// WEBPACK FOOTER //
// src/components/TopBanner/TopBanner.vue